import React, {memo, useMemo} from "react";
import {Document, Font, Image, Page, pdf, StyleSheet, Text} from "@react-pdf/renderer";

import {formatPrice} from "../../../../utils/formatPrice";



Font.register({
    family: "Roboto",
    fonts: [
        {
            src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf",
            fontWeight: "normal",
        },
        {
            src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
            fontWeight: "bold",
        },
    ],
});

// PDF stillari
const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontFamily: "Roboto",
        fontSize: 10,
        backgroundColor: "#ffffff",
        position: "relative",
    },
    pageBackground: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#ffffff",
        objectFit: "cover",
        zIndex: -1,
    },
    // Header
    block:{
       position:"absolute",
        top: 68,
        left: '53%',
        fontWeight:"bold"
    },
    client:{
       position:"absolute",
        top: "68%",
        left: '20%',
        fontWeight:"bold",
        fontSize:'9px',
        width:'190px'
    },
    userName:{
       position:"absolute",
        top: "71.5%",
        left: '23%',
        fontWeight:"bold",
        fontSize:'9px',
        width:'170px',

    },
    phone:{
        position:"absolute",
        top: "75%",
        left: '27%',
        fontWeight:"bold",
        fontSize:'9px',
        width:'150px',
    },
    price:{
        position:"absolute",
        top: 65,
        left: '23%',
        fontWeight:"bold",
        fontSize:'10px',
        width:'150px',
    },
    priceMetr:{
        position:"absolute",
        top: 67,
        left: '44%',
        fontWeight:"bold",
        fontSize:'10px',
        width:'150px',
    },
    m2:{
        position:"absolute",
        top: 67,
        left: '60%',
        fontWeight:"bold",
        fontSize:'10px',
        width:'150px',
    },
    floor:{
        position:"absolute",
        top: 67,
        left: '75%',
        fontWeight:"bold",
        fontSize:'10px',
        width:'150px',
    },
    apartment_number:{
        position:"absolute",
        top: 67,
        left: '83%',
        fontWeight:"bold",
        fontSize:'10px',
        width:'150px',
    },
});

// PDF Document component
const ApartmentPDFDocument = memo(({
                                  apartment = {},
                                  order = null,
                                  userData = null,
                                  rate,
                                  user={}
                              }) => {
    const clientName = useMemo(() => userData?.customerName || order?.client?.customerName || "", [userData?.customerName, order?.client?.customerName]);
    const Page1 = useMemo(() =>
        `${process.env.REACT_APP_API_URL}/apartment_images/${apartment?.block}-block-schema/1-${apartment?.floor}-${apartment?.apartment_number}.png`,
        [apartment?.block, apartment?.apartment_number, apartment?.floor]
    );
    const Page2 = useMemo(() =>
            `${process.env.REACT_APP_API_URL}/apartment_images/${apartment?.block}-block-schema/2-${apartment?.floor}-${apartment?.apartment_number}.png`,
        [apartment?.block, apartment?.apartment_number, apartment?.floor]
    );

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Text style={styles.block}>{apartment.block || "..."}</Text>
                <Text style={styles.client}>{clientName || "..."}</Text>
                <Text style={styles.userName}>{user?.username || "..."}</Text>
                <Text style={styles.phone}>{user?.phone || "..."}</Text>
                <Image src={Page1} style={styles.pageBackground}/>
            </Page>

            <Page size="A4" style={styles.page}>
                <Text style={styles.price}>{`${formatPrice(apartment, rate)} сум` || ""}</Text>
                <Text style={styles.priceMetr}>{`${formatPrice(apartment, rate, null, null, null, null, null, false, true)} сум` || ""}</Text>
                <Text style={styles.m2}>{parseFloat(apartment.m2) || "..."}</Text>
                <Text style={styles.floor}>{apartment.floor || "..."}</Text>
                <Text style={styles.apartment_number}>{apartment.apartment_number || "..."}</Text>
                <Image src={Page2} style={styles.pageBackground}/>
            </Page>
        </Document>
    );
});


// PDF blob yaratish
export const generatePDFBlob = async (props) => {
    return await pdf(<ApartmentPDFDocument {...props} />).toBlob();
};

// PDF URL yaratish
export const generatePDFUrl = async (props) => {
    const blob = await pdf(<ApartmentPDFDocument {...props} />).toBlob();
    return URL.createObjectURL(blob);
};

// PDF yuklab olish
export const downloadPDF = async (props, fileName = "apartment.pdf") => {
    const blob = await pdf(<ApartmentPDFDocument {...props} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export default ApartmentPDFDocument;